{
  "breaches": {
    "count": "Vi har ikke fundet nogen datalækager for din konto. | Dine kontooplysninger er blevet lækket i én datalækage. | Dine kontooplysninger er blevet lækket i {count} datalækager.",
    "discovered": "Denne lækage blev først opdaget den {date}.",
    "empty": {
      "text": "Vi har ikke fundet nogen datalækager for din konto.",
      "title": "Ingen datalækager fundet"
    },
    "high": "Høj",
    "medium": "Medium",
    "title": "Datalækager",
    "watchlist": {
      "button": "Tilføj e-mail",
      "text": "Emails der bliver overvåget",
      "title": "Overvågningsliste"
    }
  },
  "cards": {
    "breaches": {
      "text": "På denne side kan du se, om data fra din e-mailkonto er blevet eksponeret i en ekstern datalækage. Vi kategoriserer datalækagerne efter deres alvorsgrad og den type af data, der er blevet lækket. Husk at skifte adgangskode, hvis dine data er blevet lækket.",
      "title": "Er dine data blevet lækket?"
    },
    "overview": {
      "text": "Hej {name}! Phishing-angreb er den mest udbredte type cyberangreb på verdensplan og udgør en stor sikkerhedsrisiko for din arbejdsplads. Her på portalen kan du lære endnu mere om phishing og andre cyberangreb, der kan ramme dig og din arbejdsplads. Du kan også følge med i dine fremskridt og gennemføre sikkerhedsmissioner.",
      "title": "Velkommen til læringsportalen!"
    },
    "quiz": {
      "text": "Tag en interaktiv quiz, der udfordrer dine evner til at skelne mellem ægte mails og phishing-mails. Quizzen er designet til at teste din viden og forståelse af de trusler, du kan møde i virkeligheden.",
      "title": "Tag en quiz"
    },
    "simulations": {
      "text": "På denne side kan du se detaljer om de phishing-simulationer, du har modtaget de seneste 90 dage. Ved at gennemse detaljerne får du en bedre forståelse for, hvordan phishing-mails er opbygget, og hvordan du beskytter dig mod dem.",
      "title": "Er du blevet phishet?"
    },
    "videos": {
      "text": "Her på siden kan du se videoer om cybertrusler og lære, hvordan du beskytter dig selv og din arbejdsplads mod dem. Der kommer løbende nye træningsvideoer, så du altid har mulighed for at tilegne dig ny viden.",
      "title": "Gør dig klar til at lære noget nyt"
    }
  },
  "certificate": {
    "certificate_of_completion": "Certifikat for gennemførelse",
    "certificate_unlocked": "Certifikat aktiveret",
    "share_on_linkedin": "Del på LinkedIn",
    "show_certificate": "Vis certifikat",
    "text": "Du har opnået et certifikat fra dit seneste kursus – hvorfor ikke vise det frem?"
  },
  "courses": {
    "all": "Alle kurser",
    "completed": {
      "badge": "Gennemført",
      "button": "Færdiggør kursus",
      "text": "Du har gennemført kurset",
      "title": "Godt gået!"
    },
    "content": {
      "breach": {
        "text": "Aktiver overvågning af databrud på din konto",
        "title": "Overvågning af datalækager"
      },
      "download": {
        "button": "Download"
      },
      "introduction": {
        "contents": "Indhold",
        "start": "Start kursus",
        "text": "Kursusbeskrivelse og oversigt",
        "title": "Introduktion"
      },
      "quiz": {
        "choose_answer": "Vælg det rigtige svar nedenfor:",
        "correct": "Korrekt",
        "correct_answer": "{label}: {answer}",
        "correct_answer_label": "Korrekt svar",
        "next_question": "Næste spørgsmål",
        "oh_no": "Øv!",
        "question_of": "Spørgsmål {current} af {total}",
        "result": {
          "button": "Afslut quiz",
          "text": "Du svarede korrekt på {correct} af {total} spørgsmål.",
          "title": "Godt gået!",
          "title_fail": "Tæt på!"
        },
        "text": "Sæt dine færdigheder på prøve med en quiz",
        "title": "Quiz",
        "view_results": "Gå til resultat",
        "well_done": "Godt gået!",
        "your_answer": "{label}: {answer}",
        "your_answer_label": "Dit svar"
      },
      "video": {
        "text": "Lær de vigtigste begreber ved at se denne video"
      }
    },
    "continue": "Fortsæt",
    "featured": "Udvalgte kurser",
    "lessons": "{count} lektioner",
    "progress": {
      "button": "Genoptag",
      "text": "Du har gennemført {pct}% af dette kursus."
    },
    "skip_video": {
      "button": "Spring over",
      "text": "Du har set denne video før. Vil du springe den over?"
    },
    "start_over": "Start forfra",
    "title": "Kurser"
  },
  "dynamic_keys": {
    "api": {
      "errors": {
        "checksum": "Spørgsmålet er udløbet",
        "network": "En fejl er opstået",
        "noResponse": "Der opstod en serverfejl",
        "streaming": {
          "manifest": "Der opstod en fejl under afspilning af videoen",
          "platform": "Din platform understøtter ikke streaming af video",
          "unavailable": "Denne video er ikke tilgængelig"
        },
        "unknown": "En ukendt fejl er opstået"
      },
      "messages": {
        "auth_failed": "Ugyldig e-mail",
        "csrf": "Genindlæs siden og prøv igen",
        "email_missing": "Ingen e-mailadresse tilknyttet konto",
        "file_not_found": "Filen eksisterer ikke",
        "general_exception": "En fejl er opstået",
        "invalid_answer": "Ugyldigt svar",
        "invalid_course": "Ugyldigt kursus",
        "invalid_domain": "Ugyldigt domæne",
        "invalid_email": "E-mailen er ugyldig",
        "invalid_grant": "Udbyder kunne ikke kontaktes",
        "invalid_locale": "Oversættelse eksisterer ikke",
        "invalid_option": "Ugyldig svarmulighed",
        "invalid_permissions": "Du har ikke tilladelse til at bruge denne funktion",
        "invalid_point": "Ugyldigt point",
        "invalid_provider": "Ugyldig udbyder",
        "invalid_quiz": "Quizzen eksisterer ikke",
        "invalid_token": "Din session er udløbet",
        "invalid_video": "Denne video eksisterer ikke",
        "missing_code": "Prøv venligst igen",
        "two_factor_code_expired": "Engangskoden er udløbet",
        "two_factor_code_invalid": "Engangskoden er ugyldig",
        "unauthorized": "Du har ikke tilladelse til at bruge denne funktion",
        "user_not_found": "Brugeren eksisterer ikke"
      },
      "validations": {
        "messages": {
          "throttle": "For mange loginforsøg. Prøv igen senere."
        }
      }
    },
    "breaches": {
      "data_classes": {
        "account_balances": "Konto saldi",
        "address_book_contacts": "Adressebog",
        "age_groups": "Aldersgrupper",
        "ages": "Alder",
        "appointments": "Aftaler",
        "apps_installed_on_devices": "Apps installeret på enheder",
        "astrological_signs": "Astrologiske tegn",
        "audio_recordings": "Lydoptagelser",
        "auth_tokens": "API tokens",
        "avatars": "Profilbillede",
        "bank_account_numbers": "Bankkonto",
        "beauty_ratings": "Skønhedsvurderinger",
        "biometric_data": "Biometriske data",
        "bios": "Biografi",
        "browser_user_agent_details": "Browserdetaljer",
        "browsing_histories": "Browserhistorier",
        "buying_preferences": "Købspræferencer",
        "car_ownership_statuses": "Bilejerskabsstatus",
        "career_levels": "Karrierestatus",
        "cellular_network_names": "Mobilnetværk",
        "charitable_donations": "Velgørende donationer",
        "chat_logs": "Chat logs",
        "credit_card_cvv": "Kreditkort CVV",
        "credit_cards": "Kreditkort",
        "credit_status_information": "Kreditstatusinformation",
        "customer_feedback": "Kundefeedback",
        "customer_interactions": "Kundeinteraktioner",
        "dates_of_birth": "Fødselsdatoer",
        "deceased_date": "Afdødedato",
        "deceased_statuses": "Afdødestatus",
        "device_information": "Enhedsinformation",
        "device_serial_numbers": "Device serienumre",
        "device_usage_tracking_data": "Enhedsanvendelse sporingsdata",
        "drinking_habits": "Drikkevaner",
        "driver_s_licenses": "Førerens licenser",
        "drug_habits": "Stofindtag",
        "eating_habits": "Spisevaner",
        "education_levels": "Uddannelsesniveau",
        "email_addresses": "E-mailadresse",
        "email_messages": "E-mailmeddelelser",
        "employers": "Arbejdsgiver",
        "employment_statuses": "Beskæftigelsesstatus",
        "encrypted_keys": "Krypterede nøgler",
        "ethnicities": "Etniciteter",
        "family_members_names": "Familiemedlemmers navne",
        "family_plans": "Familieplaner",
        "family_structure": "Familiestruktur",
        "financial_investments": "Finansielle investeringer",
        "financial_transactions": "Finansielle transaktioner",
        "fitness_levels": "Fitnessniveauer",
        "genders": "Køn",
        "geographic_locations": "Geografiske steder",
        "government_issued_i_ds": "ID-kort",
        "health_insurance_information": "Sundhedsforsikringsoplysninger",
        "historical_passwords": "Historiske adgangskoder",
        "hiv_statuses": "Hiv status",
        "home_loan_information": "Informationer om boliglån",
        "home_ownership_statuses": "Boligejerskabsstatus",
        "homepage_ur_ls": "Webadresser",
        "imei_numbers": "IMEI-nummer",
        "imsi_numbers": "IMSI-nummer",
        "income_levels": "Indkomstniveauer",
        "instant_messenger_identities": "Instant Messenger bruger",
        "ip_addresses": "IP-adresser",
        "job_applications": "Ansøgninger",
        "job_titles": "Jobtitel",
        "licence_plates": "Licenser",
        "living_costs": "Leveomkostninger",
        "login_histories": "Login-historik",
        "mac_addresses": "MAC-adresser",
        "marital_statuses": "Ægteskabsstatus",
        "mnemonic_phrases": "Sikkerhedsspørgsmål",
        "mothers_maiden_names": "Sikkerhedsspørgsmål",
        "names": "Navne",
        "nationalities": "Nationaliteter",
        "net_worths": "Indkomstniveauer",
        "nicknames": "Kælenavne",
        "occupations": "Erhverv",
        "parenting_plans": "Forældreplaner",
        "partial_credit_card_data": "Delvis kreditkortdata",
        "partial_dates_of_birth": "Delvis fødselsdatoer",
        "passport_numbers": "Pasoplysninger",
        "password_hints": "Adgangskode tips",
        "password_strengths": "Adgangskodes længde",
        "passwords": "Adgangskode",
        "payment_histories": "Betalingshistorik",
        "payment_methods": "Betalingsmetoder",
        "personal_descriptions": "Personlige beskrivelser",
        "personal_health_data": "Personlige sundhedsdata",
        "personal_interests": "Personlige interesser",
        "phone_numbers": "Telefonnumre",
        "photos": "Fotos",
        "physical_addresses": "Fysiske adresser",
        "physical_attributes": "Fysiske attributter",
        "pi_ns": "PI-nummer",
        "places_of_birth": "Fødselssted",
        "political_donations": "Politiske donationer",
        "political_views": "Politiske synspunkter",
        "private_messages": "Private beskeder",
        "professional_skills": "Faglige kvalifikationer",
        "profile_photos": "Profilbilleder",
        "purchases": "Køb",
        "purchasing_habits": "Indkøbsvaner",
        "races": "Løbevaner",
        "recovery_email_addresses": "Historisk e-mailadresse",
        "relationship_statuses": "Forholdsstatus",
        "religions": "Religioner",
        "reward_program_balances": "Belønningsprogrammer",
        "salutations": "Salutationer",
        "school_grades_class_levels": "Skolekarakterer",
        "security_questions_and_answers": "Sikkerhedsspørgsmål og svar",
        "sexual_fetishes": "Seksuelle fetishes",
        "sexual_orientations": "Seksuel orientering",
        "smoking_habits": "Rygevaner",
        "sms_messages": "SMS-beskeder",
        "social_connections": "Sociale forbindelser",
        "social_media_profiles": "Social Media-profiler",
        "social_security_numbers": "CPR-nummer",
        "spoken_languages": "Talte sprog",
        "spouses_names": "Navn på ægtefælle",
        "support_tickets": "Support billetter",
        "survey_results": "Undersøgelsesresultater",
        "taxation_records": "Beskatningsposter",
        "time_zones": "Tidszoner",
        "travel_habits": "Rejsevaner",
        "user_statuses": "Brugerstatus",
        "user_website_ur_ls": "Brugerwebstedets webadresser",
        "usernames": "Brugernavne",
        "utility_bills": "Regninger",
        "vehicle_details": "Køretøjsdetaljer",
        "website_activity": "Hjemmesideaktivitet",
        "work_habits": "Arbejdsvaner",
        "years_of_professional_experience": "Anciennitet"
      }
    },
    "certificates": {
      "compliance": "Cybersikkerhedstræning"
    },
    "courses": {
      "toc": {
        "breach-content": "Datalækager",
        "file-content": "Download",
        "intro-content": "Introduktion",
        "quiz-content": "Quiz",
        "text-content": "Case",
        "video-content": "Video"
      }
    },
    "locales": {
      "current": "dansk",
      "da_DK": "dansk",
      "de_DE": "tysk",
      "en_US": "engelsk",
      "es_ES": "Spansk",
      "fi_FI": "finsk",
      "fr_FR": "Fransk",
      "nb_NO": "norsk",
      "nl_NL": "hollandsk",
      "pl_PL": "polsk",
      "pt_PT": "portugisisk",
      "sv_SE": "svensk"
    },
    "onboarding": {
      "course": {
        "content": [
          {
            "attributes": {
              "description": "Velkommen til din personlige læringsplatform! Vi er glade for at have dig med og er ivrige efter at hjælpe dig med at nå dine læringsmål.",
              "title": "Velkommen til Moxso"
            },
            "layout": "intro-content"
          },
          {
            "attributes": {
              "title": "Sådan fungerer Moxso",
              "video_id": "af422bc9-145b-4cf4-a9d4-de16a9dcbc61"
            },
            "layout": "video-content"
          },
          {
            "layout": "breach-content"
          }
        ],
        "id": "4a36d036-d378-449a-aa85-e62afd6e31f4",
        "image": "https://edge-cdn.moxso.com/course/4SuGbThgaOWPd69hzrD8oYqkwEkTvNzDMPEoHhrK.jpg",
        "title": "Velkommen til 🙌\n",
        "video": "https://edge-cdn.moxso.com/course/Tzk7FcRcvAHMlm35ACZNK4zIsRFvQGQimfpcKeCW.mp4"
      },
      "quiz_questions": {
        "data_privacy": {
          "category": "Data Privacy Awareness",
          "options": {
            "high": "Kendt",
            "low": "Ikke kendt",
            "medium": "Noget bekendt"
          },
          "question": "Hvor bekendt er du med de grundlæggende principper for databeskyttelse (f.eks. GDPR)?"
        },
        "device_security": {
          "category": "Enhedssikkerhedspraksis",
          "options": {
            "high": "Ja, altid",
            "low": "Nej, aldrig",
            "medium": "Nogle gange"
          },
          "question": "Opdaterer du regelmæssigt dine enheder og bruger sikkerhedsværktøjer som en VPN?"
        },
        "digital_threats": {
          "category": "Bevidsthed om digitale trusler",
          "options": {
            "high": "Kendt",
            "low": "Ikke kendt",
            "medium": "Noget bekendt"
          },
          "question": "Hvor bekendt er du med digitale trusler som malware, phishing og ransomware?"
        },
        "hybrid_work": {
          "category": "Sikkerhed ved fjernarbejde",
          "options": {
            "high": "Meget selvsikker",
            "low": "Ikke selvsikker",
            "medium": "Noget selvsikker"
          },
          "question": "Hvor selvsikker er du i at opretholde sikkerhed, når du arbejder hjemmefra (f.eks. på offentlig Wi-Fi)?"
        },
        "incidents_breaches": {
          "category": "Incident Rapportering",
          "options": {
            "high": "Ja",
            "low": "Nej",
            "medium": "Jeg har en generel idé"
          },
          "question": "Kender du den korrekte procedure for at rapportere en sikkerhedshændelse eller brud?"
        },
        "passwords_accounts": {
          "category": "Passwordhåndtering",
          "options": {
            "high": "Jeg bruger en password manager",
            "low": "Jeg genbruger passwords",
            "medium": "Jeg skaber unikke, stærke passwords"
          },
          "question": "Hvordan håndterer du passwords til dine arbejdsrelaterede konti?"
        },
        "phishing": {
          "category": "Phishing Identifikation",
          "options": {
            "high": "Meget selvsikker",
            "low": "Ikke selvsikker",
            "medium": "Noget selvsikker"
          },
          "question": "Hvor selvsikker er du i at genkende phishingforsøg i e-mails eller beskeder?"
        },
        "physical_security": {
          "category": "Fysisk sikkerhedspraksis",
          "options": {
            "high": "Altid",
            "low": "Sjældent",
            "medium": "Nogle gange"
          },
          "question": "Hvor ofte sikrer du dit arbejdsområde (f.eks. ved at låse din computer, opbevare følsomme dokumenter)?"
        },
        "secure_browsing": {
          "category": "Sikre browservaner",
          "options": {
            "high": "Ja, altid",
            "low": "Nej, aldrig",
            "medium": "Nogle gange"
          },
          "question": "Undgår du at bruge offentlig Wi-Fi eller klikke på mistænkelige links, når du browser?"
        }
      },
      "steps": {
        "finished": "Færdig",
        "introduction": "Introduktion",
        "quiz": "Quiz"
      }
    },
    "partners": {
      "cancer": "Kræftens Bekæmpelse",
      "itf": "IT Forum"
    },
    "quiz": {
      "error": {
        "checksum": "Ugyldigt svar",
        "option": "Ugyldigt svar"
      },
      "intro": {
        "button": "Start quiz",
        "text": "Vi gennemgår 5 e-mails i din Moxso-indbakke. Nogle af dem kan være fra svindlere, der prøver at få adgang til følsomme data - du skal beslutte, om e-mailen er phishing eller ej. Er du klar?",
        "title": "Klar til at rapportere?"
      },
      "multiple-choice": {
        "heading": "Find fejlen i e-mailen",
        "text": "Vælg den korrekte fejl i e-mailen nedenfor"
      },
      "options": {
        "email": "E-mailen",
        "false": "Dette ER IKKE phishing",
        "help": {
          "email": "Afsenderen er IKKE pålidelig",
          "false": "E-mailen bør IKKE blive rapporteret",
          "link": "Linket fører IKKE til en pålidelig destination",
          "not-phishing": "Dette ER IKKE phishing",
          "true": "E-mailen bør blive rapporteret"
        },
        "link": "Linket",
        "not-phishing": "Dette ER IKKE phishing",
        "true": "Dette ER phishing"
      },
      "title": "Quiz",
      "true-false": {
        "heading": "Er dette en phishing-mail?",
        "text": "Find ud af, om dette er en phishing-mail eller ej"
      }
    },
    "training": {
      "training_restritions": {
        "course": {
          "description": "Dette kursus kan ikke tilgås. Valgfrie kurser er låst, men obligatorisk træning er altid tilgængelig.",
          "title": "Kursusgrænse nået"
        },
        "quiz": {
          "description": "Du har nået din træningsgrænse. Valgfrie quizzer er midlertidigt låst.",
          "title": "Quizgrænse nået"
        },
        "video": {
          "description": "Du har nået din træningsgrænse. Valgfrie videoer er låst, men obligatorisk træning er altid tilgængelig.",
          "title": "Videogrænse nået"
        }
      }
    },
    "training_restrictions": {
      "course": {
        "description": "Dette kursus kan ikke tilgås. Valgfrie kurser er låst, men obligatorisk træning er altid tilgængelig.",
        "title": "Kursusgrænse nået"
      },
      "quiz": {
        "description": "Du har nået din træningsgrænse. Valgfrie quizzer er midlertidigt låst.",
        "title": "Quizgrænse nået"
      },
      "reset": "Nulstilles mandag",
      "video": {
        "description": "Du har nået din træningsgrænse. Valgfrie videoer er låst, men obligatorisk træning er altid tilgængelig.",
        "limit_reached": "Grænse nået",
        "title": "Videogrænse nået"
      }
    },
    "videos": {
      "category": {
        "advanced": {
          "text": "Avanceret er en serie til dem, som er særligt interesseret i IT-sikkerhed og i at forstå, hvordan de bagvedliggende mekanismer inden for hacking og IT-sikkerhed fungerer. Hvis du blot ønsker en grundlæggende forståelse for IT-sikkerhed, er det ikke nødvendigt for dig at se videoerne i denne serie. Hvis du gerne vil vide mere om hacking og cyberangreb, samt hvordan du bedst kan sikre din egen IT-sikkerhed, så finder du svaret her.",
          "title": "Avanceret",
          "tooltip": "Bliv ekspert i hacking på rekordtid"
        },
        "ai": {
          "text": "AI-serien dykker ned i den komplekse rolle, som kunstig intelligens spiller i cybersikkerhed. AI tjener et dobbelt formål: Det er et afgørende værktøj for it-sikkerhedsfolk til at identificere og håndtere trusler, samtidig med at det er et effektivt våben for hackere. Denne videoserie har til formål at øge din bevidsthed om AI-genererede phishing-angreb og vejlede dig i at bruge AI på en sikker måde for at minimere fejl og mindske risikoen for hacking. For selv om AI er et vigtigt værktøj i både cyberforsvaret og -angrebet, er din adfærd fortsat den afgørende faktor for din sikkerhed.",
          "title": "AI og cybersikkerhed",
          "tooltip": "Udforsk AI’s komplekse rolle inden for cybersikkerhed"
        },
        "compliance": {
          "text": "Denne kategori indeholder videoer om vigtige love, sikkerhedsstandarder og certificeringer, der kan være med til at beskytte din arbejdsplads mod digitale trusler. Videoerne giver dig bl.a. indblik i NIS2-direktivet og DORA-forordningen, som sikrer robuste cybersikkerhedsforanstaltninger og overholdelse af internationale standarder. Videoerne giver indsigt i reglernes betydning, hvordan man opnår compliance, og hvilke konkrete krav, de stiller til virksomheders sikkerhed og risikostyring. Du får også forståelse for, hvad reglerne betyder for dig, og hvorfor de er værd at bruge tid på.",
          "title": "Certificeringer og compliance",
          "tooltip": "Få indsigt i betydningen af certificeringer og compliance"
        },
        "gdpr": {
          "text": "GDPR er en serie, der dykker ned i de regler, krav og principper, som er blevet fastsat i GDPR. GDPR blev indført i 2018, og alle virksomheder skal nu overholde GDPR, så de kan sikre integriteten og beskyttelsen af de personoplysninger, som de behandler. Serien kommer ind på de mest relevante områder inden for GDPR, som du skal kende til, så du kan behandle personoplysninger korrekt i din hverdag. Denne serie indeholder både videoer, der er målrettet alle, og videoer, der er målrettet ansatte i den private sektor.",
          "title": "GDPR",
          "tooltip": "Lær de vigtigste krav og regler i GDPR, og hvordan du kan overholde dem i din hverdag"
        },
        "hacking": {
          "text": "Livet som hacker er en serie, hvor vi har fokus på de IT-kriminelle, nemlig hackerne. Vi kigger nærmere på nogle af de metoder, som hackere bruger til at forblive anonyme på nettet, og hvordan de tjener deres penge. I videoerne vil du yderligere lære, hvilke typer af hackere, der findes, og hvorfor hackere er så svære at fange.",
          "title": "Livet som hacker",
          "tooltip": "Kom bag facaden på verdens IT-kriminelle, nemlig hackerne"
        },
        "money_laundering": {
          "text": "Hvidvaskning er en serie, der går i dybden med de forskellige metoder, som kriminelle bruger til at hvidvaske penge. Videoerne vil forklare de forskellige metoder, som kriminelle bruger til at hvidvaske penge, og hvordan man opdager og forebygger hvidvaskning.",
          "title": "Hvidvaskning",
          "tooltip": "Lær de forskellige metoder, som kriminelle bruger til at hvidvaske penge, og hvordan man opdager og forebygger hvidvaskning"
        },
        "phishing": {
          "text": "Phishing er en serie, der går i dybden med det mest udbredte cyberangreb globalt. Phishing-angreb kan både stå alene og anvendes som en måde til at indlede andre, og mere avancerede, cyberangreb på. Phishing-angreb er derudover det cyberangreb, hvor du som medarbejder alene, bærer ansvaret for ikke at blive hacket, f.eks. ved at undgå at klikke på et link i en e-mail. Phishing er et essentielt fokusområde inden for IT-sikkerhed, og videoerne i denne serie giver dig forståelsen for, hvad phishing er, hvordan det udføres, og hvordan du undgår at blive offer for et phishing-angreb.",
          "title": "Phishing",
          "tooltip": "Få indgående viden om det mest udbredte cyberangreb globalt"
        },
        "physical_security": {
          "text": "Fysisk sikkerhed er en serie, der belyser vigtigheden af god sikkerhed på arbejdspladsen og i hjemmet. Cybersikkerhed handler om mere end sikkerheden på dine enheder, det handler også om sikkerheden omkring enhederne. Mange er bekendt med fjernarbejde, og vi klæder dig på til at gøre dette så sikkert som muligt. I denne serie får du derudover indblik i alt fra besøgshåndtering, til cybersikkerhed på mobile enheder og hvilke risici, der er ved at bruge offentlige netværk.",
          "title": "Fysisk sikkerhed",
          "tooltip": "Få et indblik i hvorfor fysisk sikkerhed er et vigtigt element i stærk cybersikkerhed"
        },
        "tips_and_tricks": {
          "text": "Tips og tricks  er en serie, der hjælper dig med at øge din sikkerhed på nettet. Du vil få helt konkrete, lavpraktiske råd til, hvordan du kan øge din personlige sikkerhed på nettet og dermed også øge sikkerheden på din arbejdsplads. Videoerne forklarer yderligere hvorfor de sikkerhedsråd, du måske tidligere har modtaget af andre end os her i Moxso, er så vigtige at huske.",
          "title": "Tips og tricks",
          "tooltip": "Lær hvordan du kan øge din sikkerhed på nettet"
        },
        "types_of_hacking": {
          "text": "Typer af hacking er en serie, der giver dig indblik i de forskellige metoder, som hackere har til rådighed, når de forsøger at snyde dig. Hver episode giver dig en grundlæggende forståelse for en specifik hacking-metode. Dette indebærer kendetegnene for hacking-metoden, hvad hackerne kan få ud af netop den metode, konsekvenserne det kan få for dig, hvis du bliver hacket m.m. Ved at se videoerne i denne serie lærer du, hvordan hackerne arbejder, og du vil blive bedre rustet mod hackerangreb i fremtiden.",
          "title": "Typer af hacking",
          "tooltip": "Få et indblik i de forskellige metoder, som hackere bruger"
        },
        "uploads": {
          "text": "Denne kategori indeholder custom videoer, som er uploadet af din organisation.",
          "title": "Uploads",
          "tooltip": "Se videoer uploadet af din organisation til dine specifikke sikkerhedsbehov"
        }
      }
    }
  },
  "error_page": {
    "error_has_been_reported": "Fejlen er blevet indsendt til vores team med id: {errorId}.\n Hvis du har brug for øjeblikkelig assistance, er du velkommen til at kontakte vores supportteam på support{'@'}moxso.com.",
    "go_back": "Tilbage til startsiden",
    "text": "Der opstod en ukendt fejl, og vi kunne ikke fuldføre din anmodning. Vi beklager ulejligheden. Prøv venligst igen senere.",
    "title": "Noget gik galt"
  },
  "forms": {
    "fields": {
      "code": "Engangskode",
      "email": "E-mail"
    },
    "placeholders": {
      "email": "navn{'@'}firma.dk"
    }
  },
  "loading": "Indlæser",
  "locale": {
    "current": "Dansk",
    "danish": "Dansk",
    "dutch": "Nederlands",
    "english": "English",
    "finnish": "Suomi",
    "french": "Français",
    "german": "Deutsch",
    "norwegian": "Norsk",
    "polish": "Polski",
    "portugese": "Português",
    "spanish": "Español",
    "swedish": "Svenska"
  },
  "login": {
    "buttons": {
      "login": "Log ind",
      "next": "Næste",
      "send_one_time_code": "Send engangskode",
      "try_again": "Send kode igen"
    },
    "choose_provider": "Vælg udbyder",
    "loading": "Indlæser",
    "sso": {
      "validating": "Validerer SSO"
    },
    "title": "Log ind",
    "two_factor": {
      "text": "Vi har sendt en engangsadgangskode til din e-mail.",
      "title": "Tjek din e-mail"
    }
  },
  "mandatory": {
    "completed": {
      "text": "Du har gennemført alt det indhold, som din administrator har udvalgt til dig.",
      "title": "Godt gået!"
    },
    "deadline": "Deadline for gennemførelse: {date}",
    "next_training": "Næste tildelte træning",
    "policy_fallback_title": "Politik",
    "quiz_questions": "{count} spørgsmål",
    "retake": "Gentildelt",
    "start_quiz": "Start quiz",
    "text": "Din tildelte træning",
    "title": "Tildelt træning",
    "view_policy": "Vis politik"
  },
  "navigation": {
    "breaches": "Datalækager",
    "courses": "Kurser",
    "exit": "Afslut",
    "exit_onboarding": "Spring over",
    "login": "Login",
    "logout": "Log ud",
    "onboarding": "Introduktion",
    "onboarding_finished": "Onboarding færdig",
    "onboarding_intro": "Onboarding introduktion",
    "onboarding_quiz": "Onboarding quiz",
    "overview": "Overblik",
    "simulation_click": "Phishing simulation",
    "simulations": "Simulationer",
    "videos": "Videoer"
  },
  "onboarding": {
    "finished": {
      "button": "Begynd at lære",
      "subtitle": "Du har gennemført din onboarding! Godt gået, du er klar til at begynde at bruge Moxso. Vi er glade for at have dig med ombord og kan ikke vente med at hjælpe dig med at nå dine mål!",
      "title": "Det var det!"
    },
    "intro": {
      "form": {
        "button": "Gem og fortsæt",
        "help": "Vælg det sprog, du ønsker at bruge til din læring.",
        "label": "Vælg dit sprog",
        "placeholder": "Vælg sprog"
      },
      "header": {
        "description": "Velkommen til din læringsplatform! Vi er glade for at have dig her og er klar til at hjælpe dig med at nå dine mål. Lad os oprette din profil og tilpasse din oplevelse.",
        "title": "Velkommen til Moxso"
      }
    },
    "quiz": {
      "header": {
        "description": "Gennemfør denne korte quiz for at hjælpe os med at forstå dit nuværende niveau, så vi kan skræddersy træningen til dine behov.",
        "title": "Hvor godt kender du cybersikkerhed?"
      }
    }
  },
  "overview": {
    "start_quiz": "Tag en quiz",
    "welcome": "Velkommen tilbage"
  },
  "partner_text": "Moxsos platform præsenteres i samarbejde med {partner}.",
  "policies": {
    "cancel": {
      "text": "Denne politik er blevet annulleret af din administrator.",
      "title": "Annulleret politik"
    },
    "continue": "Fortsæt",
    "expired": {
      "text": "Denne politik er udløbet og er ikke længere tilgængelig.",
      "title": "Udløbet politik"
    },
    "focus": "Fokus",
    "history": {
      "count": "{count} signerede",
      "show_less": "Vis færre",
      "signed": "Signeret: {date}",
      "subtitle": "Gennemse politikker, du allerede har signeret.",
      "title": "Signerede politikker",
      "view_more": "Vis mere"
    },
    "next": "Næste",
    "overview": "Indholdsoversigt",
    "policy": "Policy",
    "quiz": {
      "confirmation_card_locked": "Du skal gennemføre quizzen for at fortsætte",
      "subtitle": "Vis, at du forstår politikken, ved at tage denne quiz.",
      "subtitle_completed": "Du har gennemført quizzen. Bekræft at du har læst politikken for at afslutte.",
      "title": "Quiz",
      "title_completed": "Quiz gennemført"
    },
    "reader": "Læsning",
    "signature": {
      "button": "Godkend",
      "checkbox_label": "Jeg har læst politikken",
      "company": "Virksomhed",
      "completed": {
        "button": "Afslut",
        "policy_completed": "Politik accepteret",
        "subtitle": "Godt klaret! Du har accepteret politikken.",
        "title": "Politik accepteret"
      },
      "ip_adress": "IP adresse",
      "subtitle": "Ved at bekræfte, godkender du, at du har læst og forstået politikken.",
      "title": "Godkend at du har læst politikken",
      "user_agent": "Brugeragent"
    },
    "this_policy_doesnt_exist_in_this_language": "Denne politik er ikke tilgængelig på dansk. Viser {locale}-versionen."
  },
  "quiz": {
    "analyze": {
      "text": "Analyser e-mailen og få hjælp",
      "title": "I tvivl?"
    },
    "feedback": {
      "no": "Nej",
      "text": "Var denne artikel hjælpsom?",
      "thanks": "Tak for din feedback!",
      "yes": "Ja"
    },
    "help": {
      "button": "Næste spørgsmål",
      "text": "Vi har analyseret e-mailen og fundet følgende resultat",
      "title": "Mailanalyse"
    },
    "intro": {
      "button": "Start quiz",
      "text": "Vi gennemgår 5 e-mails i din Moxso-indbakke. Nogle af dem kan være fra svindlere, der prøver at få adgang til følsomme data - du skal beslutte, om e-mailen er phishing eller ej. Er du klar?",
      "title": "Klar til at rapportere?"
    },
    "preview": "E-mailvisning",
    "question": "Spørgsmål {current} af {total}",
    "result": {
      "go_back": "Gå til dit overblik",
      "mails": "Fanget e-mail | Fangede e-mails",
      "points": "Point optjent",
      "text": {
        "bad": "Du kategoriserede desværre kun {count} e-mail korrekt. Men husk: Øvelse gør mester! | Du kategoriserede desværre kun {count} e-mails korrekt. Men husk: Øvelse gør mester!",
        "good": "Du kategoriserede {count} e-mails korrekt og gennemførte quizzen. Fortsæt det gode arbejde!"
      },
      "title": {
        "bad": "Bedre held næste gang!",
        "good": "Godt gået!"
      }
    },
    "title": "Quiz"
  },
  "resilience_score": {
    "long_text": "Din score for modstandsdygtighed måler din evne til at modstå cyberangreb. Scoren beregnes ud fra din adfærd i quizzer, videoer og simulationer. Jo højere din modstandsdygtighed er, jo bedre er du til at beskytte dig selv og din virksomhed mod cyberangreb.",
    "quizzing": {
      "text": "Øg din modstandsdygtighed ved at tage multiple choice-quizzer efter hver video.",
      "title": "Quiz"
    },
    "show_breakdown": "Vis detaljer",
    "simulations": {
      "text": "Sikker phishing-adfærd forbedrer din modstandsdygtighed. Klik aldrig, og husk at rapportere!",
      "title": "Simulationer"
    },
    "skills": {
      "text": "Dine færdigheder afhænger af, hvordan du besvare quizzer. Korrekte svar øger modstandsdygtigheden.",
      "title": "Færdigheder"
    },
    "text": "Din score måler din evne til at modstå cyberangreb.",
    "title": "Din modstandsdygtighed",
    "videos": {
      "text": "Videoer er en vigtig del af din træning. Øg din modstandsdygtighed ved at se videoer.",
      "title": "Videoer"
    }
  },
  "search": {
    "empty": "Søg blandt videoer og kurser...",
    "no_results": "Ingen resultater fundet",
    "placeholder": "Søg...",
    "popular": "Populære søgninger",
    "popular_terms": ["Ransomware", "Social Engineering"]
  },
  "simulation": {
    "alert": {
      "text": "Du har klikket på et link i et simuleret phishing-angreb, men bare rolig, det er blot en øvelse, og ingen skade er sket.",
      "title": "Dette er en phishing øvelse"
    },
    "baseline": {
      "text": "Vi tester lige nu dine kollegaer, så del venligst ikke den her besked med nogen.",
      "title": "Kan du holde på en hemmelighed?"
    },
    "branding": {
      "text": "Hvis du har nogen spørgsmål eller har brug for hjælp, så tøv ikke med at kontakte os.",
      "title": "Denne øvelse blev leveret af Moxso"
    },
    "delivered_by": {
      "text": "Denne øvelse blev leveret af Moxso på vegne af {companyName}. Hvis du har spørgsmål, er du velkommen til at kontakte {contactEmail}.",
      "title": "Om denne øvelse"
    },
    "preview": "Forhåndsvisning",
    "resilience_score": {
      "text": "Din score for modstandsdygtighed måler din evne til at modstå cyberangreb.",
      "title": "Din modstandsdygtighedsscore"
    },
    "submission": {
      "text": "Du klikkede på et link og landede på en falsk, men overbevisende hjemmeside. I et rigtigt phishing-angreb kunne dine loginoplysninger være blevet stjålet. Heldigvis var dette kun en test.",
      "title": "Hvad skete der lige?"
    },
    "training": {
      "button": "Start din træning"
    }
  },
  "simulations": {
    "count": "Du har ikke modtaget nogen simuleringer de seneste 90 dage. | Du har modtaget én simulering inden for de sidste 90 dage. | Du har modtaget {count} simuleringer inden for de seneste 90 dage.",
    "empty": {
      "text": "Du har ikke modtaget nogen simuleringer de seneste 90 dage.",
      "title": "Ingen simuleringer"
    },
    "joined": "Du blev tilmeldt træningsprogrammet",
    "title": "Simulationer",
    "tooltip": {
      "click": "Du har klikket på linket i denne simulation.",
      "report": "Du har rapporteret denne simulation.",
      "submit": "Du har logget ind på denne simulation."
    }
  },
  "sso": {
    "login_with": "Fortsæt med {provider}",
    "or": "eller benyt SSO",
    "redirect": "Omdirigerer"
  },
  "statistics": {
    "leaderboard": "Leaderboard",
    "missing_data": {
      "text": "Du har ikke optjent nok point til at se din placering på leaderboardet endnu",
      "title": "Optjen point for at se din placering"
    },
    "points_earned": "{count} point optjent",
    "resilience_score": "Modstandsdygtighed"
  },
  "videos": {
    "error": "Streaming er utilgængelig i øjeblikket",
    "latest": "Seneste videoer",
    "more": "Vis mere",
    "not_available_in_your_locale": "Denne video er ikke tilgængelig på dansk. Vi har automatisk skiftet til engelsk.",
    "play": "Start video",
    "quiz": {
      "resume": "Genoptag quiz",
      "title": "Quiz"
    },
    "related": "Relaterede videoer",
    "related_videos": "Foreslåede videoer",
    "title": "Videoer",
    "watch_again": "Se igen"
  }
}
